export function LoadingScreen() {
  return (
    <div className="min-h-screen bg-[#f8f9fa] flex flex-col items-center justify-center gap-4">
      <div className="text-6xl animate-float">🚀</div>
      <div className="w-48 h-1.5 bg-[#e1e3e4] rounded-full overflow-hidden">
        <div className="h-full progress-fill rounded-full animate-pulse" style={{ width: '60%' }} />
      </div>
      <p className="text-label-lg font-semibold text-[#6c797f]">Loading your adventure...</p>
    </div>
  );
}
